import React, { SVGProps } from 'react'

import MeasurIcon from './MeasurIcon'

export default class IconDelete extends MeasurIcon<SVGProps<SVGSVGElement>> {
  render() {
    return (
      <svg
        width="20"
        height="22"
        viewBox="0 0 20 22"
        fill="currentColor"
        {...this.props}
      >
        <path d="M8 9a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1ZM13 16v-6a1 1 0 1 0-2 0v6a1 1 0 1 0 2 0Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5 4V3a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v1h4a1 1 0 1 1 0 2h-1v13a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V6H1a1 1 0 0 1 0-2h4Zm2.293-1.707A1 1 0 0 1 8 2h4a1 1 0 0 1 1 1v1H7V3a1 1 0 0 1 .293-.707ZM4 6v13a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V6H4Z"
        />
      </svg>
    )
  }
}
